exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".chatter[data-v-090b7854] {\n  position: relative;\n  overflow: hidden;\n  overflow-y: scroll;\n  -webkit-overflow-scrolling: touch;\n  padding: 6px 14px;\n  box-sizing: border-box;\n}\n", ""]);

